import { defineMessages } from 'react-intl-next';

export const sortLabels: {
    relevance: {
        id: string;
        defaultMessage: string;
        description: string;
    }; updatedNewest: {
        id: string;
        defaultMessage: string;
        description: string;
    }; updatedOldest: {
        id: string;
        defaultMessage: string;
        description: string;
    }; createdNewest: {
        id: string;
        defaultMessage: string;
        description: string;
    }; createdOldest: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	relevance: {
		id: 'relevance',
		defaultMessage: 'Relevance',
		description: 'Option in the dropdown to sort search results by relevance, order descending',
	},
	updatedNewest: {
		id: 'updatedNewest',
		defaultMessage: 'Updated (newest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order descending',
	},
	updatedOldest: {
		id: 'updatedOldest',
		defaultMessage: 'Updated (oldest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order ascending',
	},
	createdNewest: {
		id: 'createdNewest',
		defaultMessage: 'Created (newest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order descending',
	},
	createdOldest: {
		id: 'createdOldest',
		defaultMessage: 'Created (oldest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order ascending',
	},
});
